import styled from '@emotion/styled';

export const IconWrapper = styled.div`
  display: flex;
  position: relative;
`;

export const NumberBox = styled.div`
  position: absolute;
  top: 2px;
  right: -6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  background-color: ${({ theme }) => theme.colors.primaryBlue};
  border-radius: 8px;
  color: #fff;
  font-size: 8px;
  padding-left: 1px;
  padding-top: 1px;
`;
